import { Component, OnInit } from '@angular/core';
import { Widget } from 'src/app/shared/classes/Widget';
import { WidgetInjectedData } from 'src/app/shared/classes/WidgetInjectedData';
import { ButtonColorType } from 'src/app/shared/enums/ButtonColorType';
import { ButtonType } from 'src/app/shared/enums/ButtonType';
import { IconType } from 'src/app/shared/enums/IconType';
import { ModalType } from 'src/app/shared/enums/ModalType';
import { IModalData } from 'src/app/shared/interfaces/modal/IModalData';
import { CspOnboardingModalComponent } from '../../../modal-templates/account-onboarding-modals/csp-onboarding-modal/csp-onboarding-modal.component';
import { IIntegrationInput } from './../../../../interfaces/integration/IIntegrationInput';

@Component({
    selector: 'app-csp-integration',
    templateUrl: './csp-integration.component.html',
    styleUrls: ['./csp-integration.component.sass']
})
export class CspIntegrationComponent implements OnInit {
    integrationInput: IIntegrationInput = null;
    widgetRef: Widget;
    constructor(widgetData: WidgetInjectedData) {
        this.widgetRef = widgetData.widgetRef;
    }

    ngOnInit(): void {
        this.setUpBasics();
    }
    setUpBasics() {
        this.integrationInput = {
            integrationName: this.widgetRef.widgetData.widgetInfo.text,
            integrationCategory: 'Cloud Integration',
            imageUrl: 'assets/Azure-CSP.png',
            buttons: [
                {
                    buttonName: 'Add',
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    hoverText: 'Add Azure CSP account',
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-plus'
                    },
                    function: (buttonRef) => {
                        // Open Modal
                        this.onIntegrate(buttonRef);
                    }
                }
            ],
            imagePadding: 4
        };
    }
    onIntegrate(buttonRef: any) {
        const modalArgs: IModalData = {
            modalIcon: {
                type: IconType.FONTAWSOME,
                class: 'fas fa-chalkboard-teacher'
            },
            modalName: 'On Board Azure CSP',
            modalType: ModalType.MIDDLE,
            sourceId: this.widgetRef.uniqueIdentity,
            extraStepContainerClass: 'remove-form-space',
            modalSteps: [
                {
                    stepName: 'Step 1',
                    resetModal: true,
                    stepData: {
                        componentToLoad: CspOnboardingModalComponent,
                        payload: {
                            data: {
                                create: this.widgetRef.widgetData.widgetInfo
                                    .create
                            }
                        }
                    }
                }
            ],
            modalWidthVw: 60,
            modalHeightVh: 80
        };
        this.widgetRef.modalService.openModal(modalArgs);
    }
}
